import React, { useState, useEffect } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { uniqBy, concat, cloneDeep, isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  customStylesForOCP,
  PCPLocation,
  customSectionPlacementArry,
  prouctCustmSectionAttributeList,
  productCpAttributeList,
  productCpoutComeList,
  prouctBomOutComeList,
  prouctCustmSectionOutComeList,
  PCPSublocationList,
  poProductoutComeList,
  filterCustomAttributesDropdownAndTextType,
  RightsAccess,
  PIMDisplayFormat,
  bomSelection,
} from '../../../../../../Components/helper';
import Loader from '../../../../../../Components/Utility/Loader/Loader';
import * as customAction from '../../../../../RangePlan/CustomSections/store/CustomSections.action';
import * as systemMasterAction from '../../../../../SystemMasters/Store/SystemMasters.action';
import * as action from '../../../Store/CustomModule.action';
import * as devOrderAction from '../../../../../DevlopmentOrder/store/DevelopmentOrder.action';
import { useCustomModuleState } from '../../../Context/index';

export default function SourceComponent({ gridIndex, index, setIsLabel, pageIndex, deleteItem, onChange, setIsEditLabel, showEdit, setDroppedIndex }) {
  const {
    SystemMastersDetails: { customAttributeList, mainSampleList, otherSamplesList, measurement_master, placement_master, subBrandAccess },
    customSectionData: { bomTypes, sampleTrackingDates, currSectionList, customColumnList },
    UserDetails: { userInfo },
    CustomModuleReducer: { customLibraryList, customLibraryDetail, customModulePageControlList, customModulePages },
  } = useSelector((reducer) => reducer);
  const { t } = useTranslation('common');
  const { rangePlanRight, TestingRight } = RightsAccess();
  const dispatch = useDispatch();
  const { moduleLibId } = useParams();
  const loggedInUserId = userInfo?.userId;
  const { customModuleState, setCustomModuleState } = useCustomModuleState();
  const careUserDocumentInformation = 'Care/User_Document_Information';

  useEffect(() => {
    setCustomModuleState((prevState) => ({ ...prevState, disableDrag: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [state, setState] = useState({
    loading: false,
    sampleType: [],
    name: '',
    location: null,
    locationType: null,
    locationPlacement: null,
    attribute: null,
    output: null,
    subLocation: null,
    pages: null,
    control: null,
    tableColumn: null,
    hasError: false,
    mainLoader: false,
    pom: null,
    displayFormat: null,
  });
  const [locationOptions, setLocationOptions] = useState(PCPLocation);
  const [customOptions, setCustomOptions] = useState([]);
  const [controlOptions, setControlOptions] = useState([]);
  const [manualCustomColumns, setManualCustomColumns] = useState([]);
  const [isTableControlSelected, setIsTableControlSelected] = useState(false);
  const [tableColumns, setTableColumns] = useState([]);
  const [dynamicBomSelection, setDynamicBomSelection] = useState([]);

  useEffect(() => {
    if (!TestingRight) {
      const updatedData = PCPLocation.filter((item) => item.name !== 'Testing');
      setLocationOptions(updatedData);
    }
  }, [PCPLocation, TestingRight]);

  useEffect(() => {
    // Create dynamic BOM selection with all BOM types plus "All Item"
    if (bomTypes && bomTypes.length > 0) {
      const bomTypeOptions = bomTypes.map((bomType) => ({
        label: bomType.name,
        name: bomType._id,
      }));
      setDynamicBomSelection([...bomTypeOptions, ...bomSelection]);
    } else {
      // Fallback to static options when no BOM types available
      setDynamicBomSelection([...bomSelection]);
    }
  }, [bomTypes]);

  useEffect(() => {
    if (customColumnList) {
      const manualColumns = [];
      manualColumns.push(
        ...(customColumnList?.columns ?? []).filter(
          (colmElement) => colmElement?.columnType === 'manual' && (colmElement?.type === 'Number' || colmElement?.type === 'Number_percentage'),
        ),
      );
      setManualCustomColumns(manualColumns?.map((cEle) => ({ label: cEle?.title, name: cEle?._id })));
    }
  }, [customColumnList]);

  useEffect(() => {
    const allColumns = [];
    if (currSectionList && !isEmpty(currSectionList)) {
      currSectionList?.forEach((sectionElement) => {
        const checkManualExist = sectionElement.columns.find((vl) => vl?.columnType === 'manual');
        if (checkManualExist) {
          allColumns.push(sectionElement);
        }
      });
      const maualColumns = allColumns?.map((cEle) => {
        return {
          label: cEle?.name,
          name: cEle?._id,
          _id: 12,
        };
      });
      setLocationOptions((arr) => [...arr, ...maualColumns]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currSectionList]);

  const apiCallForSubLocation = async () => {
    if (customModuleState?.editpopupChildData?.relation?.subLocation && customModuleState?.editpopupChildData?.relation?.location?._id === 7) {
      setState((prev) => ({ ...prev, loading: true }));
      const res = await Promise.all([
        dispatch(action.getCMPagesList(customModuleState?.editpopupChildData?.relation?.subLocation?.name)),
        dispatch(
          action.getCMPageControlList(
            customModuleState?.editpopupChildData?.relation?.subLocation?.name,
            customModuleState?.editpopupChildData?.relation?.pages?.name,
          ),
        ),
      ]);

      if (res) {
        setState((prev) => ({ ...prev, loading: false }));
      }
    }
  };

  const fetchingCustomColumns = async (value) => {
    setState((oldState) => ({ ...oldState, loading: true }));
    if (value?.name) {
      const res = await dispatch(customAction.fetchCustomColumnList(value?.name));
      if (res) {
        setState((oldState) => ({ ...oldState, loading: false }));
      }
    }
  };

  const fetchingEcomValues = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    const ecomValues = await dispatch(devOrderAction.getEcommSpec('eCommSpec'));
    if (ecomValues?.isActive) {
      await dispatch(systemMasterAction.getMeasurementDetails({ isActive: true }));
    }
    setState((prev) => ({ ...prev, loading: false }));
  };

  useEffect(() => {
    if (customModuleState?.modalEdit) {
      if (customModuleState?.editpopupChildData?.relation?.subLocation && customModuleState?.editpopupChildData?.relation?.location?._id === 12) {
        fetchingCustomColumns();
      }
      if (
        customModuleState?.editpopupChildData?.relation?.subLocation?.name === 'ecomSpec' &&
        customModuleState?.editpopupChildData?.relation?.location?._id === 4
      ) {
        fetchingEcomValues();
      }
      apiCallForSubLocation();
      /* On Edit Modal Check if table control selected then set table columns */
      if (customModuleState?.editpopupChildData?.relation?.control?.key === 'Table') {
        setIsTableControlSelected(true);
        setTableColumns(customModuleState?.editpopupChildData?.relation?.control?.tableColumns?.filter((eleCol) => eleCol?.key === 'Status'));
      }
      setState((prevState) => ({
        ...prevState,
        ...customModuleState?.editpopupChildData?.relation,
        name: customModuleState?.editpopupChildData?.label,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customModuleState?.modalEdit, customModuleState?.editpopupChildData?.label, customModuleState?.editpopupChildData?.relation]);

  useEffect(() => {
    if (customLibraryList && !isEmpty(customLibraryList)) {
      const maualCustomColumns = customLibraryList?.map((cEle) => {
        return {
          label: cEle?.moduleName,
          name: cEle?._id,
          _id: 7,
        };
      });
      setCustomOptions(maualCustomColumns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customLibraryList, moduleLibId]);

  useEffect(() => {
    if (state?.location?._id === 7 && state?.pages) {
      const controls = customModulePageControlList
        ?.filter((element) => {
          return element?.control && !['Colorfill', 'Divider', 'Source'].includes(element?.control?.key);
        })
        ?.map((ele) => {
          const { options, ...rest } = ele.control;
          return { ...rest, name: rest.key, parentType: 'control', i: ele.i };
        });
      setControlOptions(controls);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customModulePageControlList, state?.pages]);

  useEffect(() => {
    const sampleSelectionType = concat(mainSampleList, otherSamplesList).map((element) => {
      return { label: element?.name, name: element?._id };
    });
    setState((prevState) => ({
      ...prevState,
      sampleType: sampleSelectionType,
    }));
  }, [mainSampleList, otherSamplesList]);

  useEffect(() => {
    if (state?.control?.key === 'Table') {
      setIsTableControlSelected(true);
      setTableColumns(state?.control?.tableColumns?.filter((eleCol) => eleCol?.key === 'Status'));
    } else {
      setIsTableControlSelected(false);
      setTableColumns([]);
    }
  }, [state?.control]);

  const placementLabel = () => {
    if (state?.location?.name === 'Bill_of_Materials' && state?.locationType?.name !== 'all_item') {
      return t('CUSTOM_LIBRARY.SOURCE_TYPE.PLACEMENT');
    }
    return t('CUSTOM_LIBRARY.SOURCE_TYPE.POSITION');
  };

  const setOptionsForAttribute = () => {
    if (
      [
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Specifications',
        'Samples',
        'Costing_Information',
        'Completion_Indicator',
      ].includes(state?.location?.name)
    ) {
      return [...productCpAttributeList.filter((attributeElement) => ['valueType'].includes(attributeElement?.name))];
    }
    if (state?.location?.name === 'Purchase_Order') {
      return [...productCpAttributeList.filter((attributeElement) => ['all_item', 'valueType'].includes(attributeElement?.name))];
    }
    if (state?.location?.name === 'Bill_of_Materials') {
      return [...productCpAttributeList.filter((attributeElement) => attributeElement?.name !== 'valueType')];
    }
    if (['Design_Details'].includes(state?.location?.name)) {
      return [...productCpAttributeList.filter((attributeElement) => ['first_item', 'last_item'].includes(attributeElement?.name))];
    }
    if (['Testing', careUserDocumentInformation].includes(state?.location?.name)) {
      return [...productCpAttributeList.filter((attributeElement) => !['valueType'].includes(attributeElement?.name))];
    }
    if (state?.location?._id === 12) {
      return [...productCpAttributeList.filter((attributeElement) => attributeElement?.name !== 'all_item')];
    }
    return productCpAttributeList;
  };

  const setPlacementForLocation = () => {
    if (['Bill_of_Materials'].includes(state?.location?.name)) {
      const selectedBomTypeId = state?.locationType?.name;
      if (!selectedBomTypeId || selectedBomTypeId === 'all_item') {
        return placement_master?.map((val) => ({ name: val?._id, label: val?.name })) ?? [];
      }
      const filteredPlacementMasters = placement_master?.filter((val) => Array.isArray(val?.bomType) && val?.bomType?.includes(selectedBomTypeId)) ?? [];
      return filteredPlacementMasters.map((val) => ({ name: val?._id, label: val?.name }));
    }
    return customSectionPlacementArry;
  };

  const hideShowAttribute = () => {
    return (
      [
        'Design_Details',
        'Specifications',
        'Testing',
        careUserDocumentInformation,
        'Costing_Information',
        'Purchase_Order',
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Completion_Indicator',
      ].includes(state?.location?.name) ||
      state?.location?._id === 12 ||
      (state?.location?.name === 'Bill_of_Materials' && state?.locationPlacement) ||
      (state?.location?.name === 'Bill_of_Materials' && state?.locationType?.name === 'all_item') ||
      (state?.location?.name === 'Samples' && state?.locationPlacement?.name)
    );
  };

  const hideShowPlacement = () => {
    return (
      (state?.location?.name === 'Bill_of_Materials' && state?.locationType && state?.locationType?.name !== 'all_item') ||
      (state?.location?.name === 'Samples' && state?.locationType?.name)
    );
  };

  const hideShowSubLocation = () => {
    return (
      ['Product_Core_Information', 'Product_Information', 'Supplier_Information', 'Specifications', 'Costing_Information'].includes(state?.location?.name) ||
      (state?.location?._id === 12 && state?.output) ||
      (state?.location?.name === 'Bill_of_Materials' && state?.locationType?.name !== 'all_item' && state?.output?.name === 'valueType') ||
      (state?.location?.name === 'Samples' && state?.attribute?.name) ||
      (state?.location?.name === 'Purchase_Order' && state?.attribute?.name === 'valueType') ||
      (state?.location?.name === 'Completion_Indicator' && state?.attribute?.name) ||
      state?.location?._id === 7
    );
  };

  const hideShowOutput = () => {
    if ((state?.location?.name === 'Bill_of_Materials' || state?.location?._id === 12) && state?.attribute?.name === 'valueType') {
      return false;
    }
    return (
      ((['Design_Details', 'Testing', 'Bill_of_Materials', 'Care/User_Document_Information', 'Custom_Section'].includes(state?.location?.name) ||
        state?.location?._id === 12) &&
        state?.attribute?.name) ||
      (state?.location?.name === 'Purchase_Order' && state?.attribute?.name === 'all_item')
    );
  };

  const testingOutputList = () => {
    return productCpoutComeList.filter((outputItem) =>
      ['first_item', 'last_item'].includes(state?.attribute?.name) ? ['date_added'].includes(outputItem?.name) : outputItem?.name === 'percentage_of_approval',
    );
  };

  const setOptionsForOutput = () => {
    if (['Testing', careUserDocumentInformation].includes(state?.location?.name)) {
      return [...testingOutputList()];
    }
    if (state?.location?.name === 'Design_Details') {
      return [...productCpoutComeList.filter((outputItem) => ['date_added'].includes(outputItem?.name)), { label: 'Status Date', name: 'status_date' }];
    }
    if (state?.location?._id === 12) {
      return [...productCpoutComeList.filter((outputItem) => ['date_added'].includes(outputItem?.name))];
    }
    if (state?.location?.name === 'Purchase_Order') {
      return [...poProductoutComeList.filter((outputItem) => outputItem?.name === 'completion_percentage')];
    }
    if (state?.location?.name === 'Bill_of_Materials') {
      if (state?.locationType?.name !== 'all_item' && ['first_item', 'last_item'].includes(state?.attribute?.name)) {
        return [...productCpoutComeList.filter((outputItem) => ['date_added'].includes(outputItem?.name))];
      }
      return ['first_item', 'last_item'].includes(state?.attribute?.name)
        ? [...productCpoutComeList.filter((outputItem) => ['date_added'].includes(outputItem?.name))]
        : [...productCpoutComeList.filter((outputItem) => outputItem?.name === 'percentage_of_approval')];
    }
    return state?.location?._id === 12 ? prouctCustmSectionOutComeList : productCpoutComeList;
  };

  const setOptionsForBomOutput = () => {
    if (
      state?.location?.name === 'Bill_of_Materials' &&
      state?.locationType?.name !== 'all_item' &&
      ['first_item', 'last_item'].includes(state?.attribute?.name)
    ) {
      return prouctBomOutComeList.filter((ele) => ele.name !== 'percentage_of_approval');
    }
    if (
      state?.location?.name === 'Bill_of_Materials' &&
      state?.locationType?.name === 'all_item' &&
      ['first_item', 'last_item'].includes(state?.attribute?.name)
    ) {
      return prouctBomOutComeList.filter((ele) => ele.name === 'date_added');
    }
    if (state?.location?.name === 'Bill_of_Materials' && state?.attribute?.name === 'all_item') {
      return prouctBomOutComeList.filter((ele) => ele.name === 'percentage_of_approval');
    }
    return prouctCustmSectionOutComeList;
  };

  const pageSubLocations = () => {
    return customModulePages?.pages
      ?.filter((e) => !e?.isContectPage)
      ?.map((element) => ({
        label: element?.pageTitle,
        name: element?._id,
        type: 'page',
      }));
  };

  const setSubLocationArr = () => {
    const locationId = state?.location?._id;
    if (locationId === 12) {
      return manualCustomColumns;
    }
    let subLocationArr = cloneDeep(PCPSublocationList?.find((val) => val?.locationId === locationId) || {});
    if (!subLocationArr?.subLocations) {
      const findLocation = locationOptions.find((loc) => loc?.name === state?.location?.name);
      subLocationArr = cloneDeep(PCPSublocationList?.find((val) => val?.locationId === findLocation?._id) || {});
    }
    let manipulatedDynamicColumns = [];
    const mcColumn = filterCustomAttributesDropdownAndTextType(customAttributeList);
    manipulatedDynamicColumns = [];
    mcColumn?.forEach((dyCol) => {
      if (dyCol.isActive) {
        manipulatedDynamicColumns.push({
          label: dyCol?.keyName,
          name: dyCol?._id,
          type: 'string',
        });
      }
    });
    const sampleTrackingArr = sampleTrackingDates?.map((dyCol) => {
      return {
        label: dyCol?.name,
        name: dyCol?._id,
        type: 'date',
      };
    });
    if (state?.location?.name === 'Product_Information') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations, manipulatedDynamicColumns);
    }

    if (state?.location?.name === 'Specifications') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations);
    }
    if (state?.location?.name === 'Samples') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations, sampleTrackingArr);
    }

    if (state?.location?._id === 11 && Array.isArray(subLocationArr?.subLocations) && subBrandAccess) {
      subLocationArr.subLocations = concat(subLocationArr.subLocations, [{ label: 'Sub Brand', name: 'subBrand', type: 'string' }]);
    }

    return subLocationArr.subLocations;
  };

  useEffect(() => {
    const callFn = async () => {
      setState((oldState) => ({
        ...oldState,
        loading: true,
      }));
      if (rangePlanRight) {
        dispatch(customAction.fetchAllSections());
        dispatch(action.getAllCustomModule({ isAllRecord: true }));
      }
      await Promise.all([
        dispatch(customAction.fetchCustomSectionBomTypeAction({ isAllRecord: true })),
        dispatch(systemMasterAction.getMainSampleDetails({ loggedInUserId })),
        dispatch(systemMasterAction.getOtherSamplesDetails({ loggedInUserId })),
        dispatch(systemMasterAction.getPlacementDetails({ loggedInUserId, isActive: true })),
        dispatch(systemMasterAction.getCustomAttributeFreeText({ isActive: true })),
        dispatch(customAction.getAllMeasurment()),
        dispatch(customAction.getSampleTrackingDates()),
      ]);

      setState((oldState) => ({
        ...oldState,
        loading: false,
      }));
    };
    if (!isEmpty(loggedInUserId)) callFn();
  }, [loggedInUserId, dispatch]);

  const setAttrinuteToValue = (getLocation, getLocationPlacment) => {
    return (
      ['Product_Core_Information', 'Product_Information', 'Supplier_Information', 'Specifications', 'Costing_Information', 'Completion_Indicator'].includes(
        getLocation,
      ) ||
      (getLocation === 'Samples' && ['earliest', 'mostRecent'].includes(getLocationPlacment))
    );
  };

  const handleChange = async (keyName, value, removeArray) => {
    delete value?.tableData;

    const clonedState = cloneDeep(state);
    clonedState[keyName] = value;
    if (keyName === 'location' && value?._id === 12) {
      await fetchingCustomColumns(value);
    }
    if (keyName === 'subLocation' && state?.location?._id === 7) {
      setState((prev) => ({ ...prev, loading: true }));
      const res = await dispatch(action.getCMPagesList(value?.name));
      if (res) {
        setState((prev) => ({ ...prev, loading: false }));
      }
    }
    if (keyName === 'pages' && state?.location?._id === 7) {
      setState((prev) => ({ ...prev, loading: true }));
      const res = await dispatch(action.getCMPageControlList(state?.subLocation?.name, value?.name));
      if (res) {
        setState((prev) => ({ ...prev, loading: false }));
      }
    }
    if (keyName === 'location' && value?._id === 4) {
      fetchingEcomValues();
    }

    if (removeArray && removeArray?.length > 0) {
      removeArray?.forEach((element) => {
        clonedState[element] = null;
      });
    }
    if (
      setAttrinuteToValue(
        keyName === 'location' ? value?.name : state?.location?.name,
        keyName === 'locationPlacement' ? value?.name : state?.locationPlacement?.name,
      )
    ) {
      clonedState.attribute = {
        label: 'Value',
        name: 'valueType',
      };
    }
    setState(clonedState);
  };

  const hideShowPage = () => {
    return state?.location?._id === 7 && state?.subLocation;
  };
  const hideShowControl = () => {
    return state?.location?._id === 7 && state?.subLocation && state?.pages;
  };
  const hideShowEcomOptions = () => {
    return state?.location?._id === 4 && state?.subLocation?.name === 'ecomSpec';
  };
  const valiDateState = async () => {
    let valid = true;
    if (
      !state?.location ||
      (hideShowSubLocation() && !state?.subLocation) ||
      (['Bill_of_Materials', 'Samples'].includes(state?.location?.name) && !state?.locationType) ||
      (hideShowPlacement() && !state?.locationPlacement) ||
      (hideShowOutput() && !state?.output) ||
      (hideShowAttribute() && !state?.attribute) ||
      (hideShowPage() && !state?.pages) ||
      (hideShowControl() && !state?.control) ||
      (hideShowEcomOptions() && !state?.pom) ||
      (hideShowEcomOptions() && !state?.displayFormat) ||
      (isTableControlSelected && !state?.tableColumn)
    ) {
      valid = false;
    }
    return valid;
  };

  const handleSubmit = async () => {
    const isValid = await valiDateState();
    if (isValid) {
      if (customModuleState?.modalEdit) {
        setIsEditLabel(true);
        const relationObject = {};
        const keysNeeded = ['location', 'locationType', 'locationPlacement', 'attribute', 'output', 'subLocation', 'pages', 'control', 'tableColumn'];
        keysNeeded.forEach((key) => {
          if (state[key] !== null) {
            relationObject[key] = state[key];
          }
        });
        onChange({ relation: relationObject, label: state?.name }, 'relation', customModuleState?.editPopupGridIndex, customModuleState?.editPopupPageIndex);
      } else {
        setIsLabel(true);
        const relationObject = {};
        const keysNeeded = [
          'location',
          'locationType',
          'locationPlacement',
          'attribute',
          'output',
          'subLocation',
          'pages',
          'control',
          'tableColumn',
          'pom',
          'displayFormat',
        ];
        keysNeeded.forEach((key) => {
          if (state[key] !== null) {
            relationObject[key] = state[key];
          }
        });
        onChange({ relation: relationObject, label: state?.name }, 'relation', gridIndex, pageIndex);
      }
      setCustomModuleState((prevState) => ({
        ...prevState,
        modalEdit: false,
        editPopupGridInd: -1,
        editPopupPageIndex: -1,
        editpopupChildData: null,
        editPopup: false,
        disableDrag: false,
      }));
    } else {
      setState((prevState) => ({ ...prevState, hasError: true }));
    }
  };

  const handleClose = () => {
    if (moduleLibId) {
      setIsEditLabel(true);
      if (!customLibraryDetail?.pages?.[pageIndex]?.grid?.[gridIndex]?.control?.relation) {
        deleteItem(gridIndex, pageIndex, true);
      }
    } else {
      setIsLabel(true);
      if (!customLibraryDetail?.pages?.[pageIndex]?.grid?.[gridIndex]?.control?.relation) {
        deleteItem(gridIndex, pageIndex);
      }
    }
    setCustomModuleState((prevState) => ({
      ...prevState,
      modalEdit: false,
      editPopupGridInd: -1,
      editPopupPageIndex: -1,
      editpopupChildData: null,
      editPopup: false,
      disableDrag: false,
      droppedIndex: -1,
    }));
    setDroppedIndex(-1);
  };

  return (
    <Modal className="custom-modal ocp-modal" show={!showEdit}>
      <Modal.Header>{t('CUSTOM_LIBRARY.SOURCE_TYPE.CREATE_RELATION')}</Modal.Header>
      <Modal.Body>
        {state?.mainLoader ? (
          <Loader />
        ) : (
          <>
            <div key={`source_${gridIndex}_${pageIndex}_${index}`}>
              <Row className="px-3">
                <Col lg={12} className="mb-3">
                  <p className="asterisk-req f-14 mb-0">
                    {t('CUSTOM_LIBRARY.SOURCE_TYPE.LOCATION')} <span>*</span>
                  </p>
                  <Select
                    name="location"
                    options={uniqBy(locationOptions, 'name')} // locationList
                    getOptionLabel={(option) => `${option.label}`}
                    getOptionValue={(option) => `${option.name}`}
                    maxMenuHeight={140}
                    menuPosition="fixed"
                    value={state?.location}
                    styles={customStylesForOCP}
                    onChange={(e) =>
                      handleChange('location', e, [
                        'subLocation',
                        'attribute',
                        'output',
                        'locationType',
                        'locationPlacement',
                        'pages',
                        'control',
                        'pom',
                        'displayFormat',
                      ])
                    }
                    placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.SELECT_LOCATION')}
                  />
                  {state?.hasError && !state?.location && <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.LOCATION_MISSING')}</span>}
                </Col>
                {['Bill_of_Materials', 'Samples'].includes(state?.location?.name) && (
                  <Col lg="12" className=" mb-3">
                    <p className="asterisk-req f-14 mb-0">
                      {state?.location?.name === 'Bill_of_Materials' ? t('CUSTOM_LIBRARY.SOURCE_TYPE.BOM_TYPE') : t('CUSTOM_LIBRARY.SOURCE_TYPE.LOCATION_TYPE')}{' '}
                      <span>*</span>
                    </p>
                    <Select
                      name="locationType"
                      isLoading={state?.loading}
                      options={state?.location?.name === 'Samples' ? state?.sampleType : dynamicBomSelection || []}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.name}`}
                      value={state?.locationType}
                      styles={customStylesForOCP}
                      maxMenuHeight={120}
                      menuPosition="fixed"
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.SELECT_TYPE')}
                      onChange={(selected) =>
                        handleChange('locationType', selected, [
                          'subLocation',
                          'attribute',
                          'output',
                          'locationPlacement',
                          'pages',
                          'control',
                          'pom',
                          'displayFormat',
                        ])
                      }
                    />
                    {state?.hasError && !state?.locationType && (
                      <span className="error-message">{`${
                        state?.location?.name === 'Samples'
                          ? t('CUSTOM_LIBRARY.SOURCE_TYPE.SAMPLE_TYPE_MISSING')
                          : t('CUSTOM_LIBRARY.SOURCE_TYPE.BOM_TYPE_MISSING')
                      }`}</span>
                    )}
                  </Col>
                )}
                {hideShowPlacement() && (
                  <Col lg="12" className=" mb-3">
                    <p className="asterisk-req f-14 mb-0">
                      {placementLabel()} <span>*</span>
                    </p>
                    <Select
                      name="locationPlacement"
                      options={setPlacementForLocation() || []}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.name}`}
                      value={state?.locationPlacement}
                      styles={customStylesForOCP}
                      maxMenuHeight={120}
                      menuPosition="fixed"
                      placeholder={placementLabel()}
                      isLoading={state?.loading}
                      onChange={(selected) =>
                        handleChange('locationPlacement', selected, ['subLocation', 'attribute', 'output', 'pages', 'control', 'pom', 'displayFormat'])
                      }
                    />
                    {state?.hasError && !state?.locationPlacement && <span className="error-message">{`${placementLabel()} is required.`}</span>}
                  </Col>
                )}
                {hideShowAttribute() && (
                  <Col lg={12} className="mb-3">
                    <p className="asterisk-req f-14 mb-0">
                      {t('CUSTOM_LIBRARY.SOURCE_TYPE.ATTRIBUTE')} <span>*</span>
                    </p>
                    <Select
                      name="attribute"
                      options={state?.location?._id === 12 ? prouctCustmSectionAttributeList : setOptionsForAttribute()}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.name}`}
                      value={state?.attribute}
                      maxMenuHeight={140}
                      menuPlacement="bottom"
                      menuPosition="fixed"
                      menuShouldBlockScroll
                      menuShouldScrollIntoView
                      styles={customStylesForOCP}
                      isLoading={state?.loading}
                      onChange={(selected) => handleChange('attribute', selected, ['subLocation', 'output', 'pages', 'control', 'pom', 'displayFormat'])}
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.SELECT_ATTRIBUTE')}
                    />
                    {state?.hasError && !state?.attribute && <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.ATTRIBUTE_MISSING')}</span>}
                  </Col>
                )}
                {hideShowOutput() && (
                  <Col lg={12} className="mb-3">
                    <p className="asterisk-req f-14 mb-0">
                      {t('CUSTOM_LIBRARY.SOURCE_TYPE.OUTPUT')} <span>*</span>
                    </p>
                    <Select
                      name="Output"
                      options={state?.location?.name === 'Bill_of_Materials' ? setOptionsForBomOutput() : setOptionsForOutput()}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.name}`}
                      value={state?.output}
                      maxMenuHeight={140}
                      styles={customStylesForOCP}
                      menuPlacement="bottom"
                      menuPosition="fixed"
                      menuShouldBlockScroll
                      menuShouldScrollIntoView
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.SELECT_OUTCOME')}
                      onChange={(selected) => handleChange('output', selected, ['subLocation', 'pages', 'control', 'pom', 'displayFormat'])}
                      isLoading={state?.loading}
                    />
                    {state?.hasError && !state?.output && <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.OUTPUT_MISSING')}</span>}
                  </Col>
                )}
                {hideShowSubLocation() && (
                  <Col lg="12" className="mb-3">
                    <p className="asterisk-req f-14 mb-0">
                      {t('CUSTOM_LIBRARY.SOURCE_TYPE.SUB_LOCATION')} <span>*</span>
                    </p>
                    <Select
                      name="SubLocation"
                      options={(state?.location?._id === 7 ? customOptions : setSubLocationArr()) || []}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.name}`}
                      value={state?.subLocation}
                      styles={customStylesForOCP}
                      maxMenuHeight={120}
                      menuPosition="fixed"
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.SELECT_SUB_LOCATION')}
                      isLoading={state?.loading}
                      onChange={(selected) => handleChange('subLocation', selected, ['pages', 'control', 'pom', 'displayFormat'])}
                    />
                    {state?.hasError && !state?.subLocation && <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.SUB_LOCATION_MISSING')}</span>}
                  </Col>
                )}
                {hideShowPage() && (
                  <Col lg="12" className="mb-3">
                    <p className="asterisk-req f-14 mb-0">
                      {t('CUSTOM_LIBRARY.SOURCE_TYPE.PAGES')} <span>*</span>
                    </p>
                    <Select
                      name="pages"
                      options={pageSubLocations() || []}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.name}`}
                      value={state?.pages}
                      styles={customStylesForOCP}
                      maxMenuHeight={120}
                      menuPosition="fixed"
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.SELECT_PAGE')}
                      isLoading={state?.loading}
                      onChange={(selected) => handleChange('pages', selected, ['control', 'pom', 'displayFormat'])}
                    />
                    {state?.hasError && !state?.pages && <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.PAGES_MISSING')}</span>}
                  </Col>
                )}
                {hideShowControl() && (
                  <Col lg="12" className="mb-3">
                    <p className="asterisk-req f-14 mb-0">
                      {t('CUSTOM_LIBRARY.SOURCE_TYPE.CONTROLS')} <span>*</span>
                    </p>
                    <Select
                      name="controls"
                      options={controlOptions || []}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.name}_${option?.i}`}
                      value={state?.control}
                      menuPosition="fixed"
                      styles={customStylesForOCP}
                      maxMenuHeight={120}
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.SELECT_CONTROL')}
                      isLoading={state?.loading}
                      onChange={(selected) => handleChange('control', selected)}
                    />
                    {state?.hasError && !state?.control && <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.CONTROLS_MISSING')}</span>}
                  </Col>
                )}
                {isTableControlSelected && (
                  <Col lg="12" className="mb-3">
                    <p className="asterisk-req f-14 mb-0">
                      {t('CUSTOM_LIBRARY.SOURCE_TYPE.TABLE_COLUMN')} <span>*</span>
                    </p>
                    <Select
                      name="controls"
                      options={tableColumns || []}
                      getOptionLabel={(option) => `${option.fieldName}`}
                      getOptionValue={(option) => `${option.fieldName}_${option?.i}`}
                      value={state?.tableColumn}
                      menuPosition="fixed"
                      styles={customStylesForOCP}
                      maxMenuHeight={120}
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.SELECT_COLUMN')}
                      isLoading={state?.loading}
                      onChange={(selected) => handleChange('tableColumn', selected)}
                    />
                    {state?.hasError && !state?.tableColumn && <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.COLUMN_REQUIRED')}</span>}
                  </Col>
                )}
                {hideShowEcomOptions() && (
                  <>
                    <Col lg={12} className="mb-3">
                      <label htmlFor="point_measure" className="asterisk-req f-14 mb-0">
                        {t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.POINT_MEASURE')} <span>*</span>
                      </label>
                      <Select
                        name="PointOfMeasure"
                        options={measurement_master?.map((e) => ({ label: e?.name, name: e?._id })) || []}
                        getOptionLabel={(option) => `${option.label}`}
                        getOptionValue={(option) => `${option.name}`}
                        value={state?.pom}
                        styles={customStylesForOCP}
                        maxMenuHeight={120}
                        placeholder={t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.SELECT_SUB_LOCATION')}
                        isLoading={state?.loading}
                        onChange={(selected) => handleChange('pom', selected)}
                      />
                      {state.hasError && !state?.pom && (
                        <span className="error-message">{t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.POINT_OF_MEASURE_REQUIRED')}</span>
                      )}
                    </Col>
                    <Col lg="12">
                      <label htmlFor="display_format" className="asterisk-req f-14 mb-0">
                        {t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.DISPLAY_FORMAT')}
                        <span>*</span>
                      </label>
                      <Select
                        name="DisplayFormat"
                        options={PIMDisplayFormat || []}
                        getOptionLabel={(option) => `${option.label}`}
                        getOptionValue={(option) => `${option.name}`}
                        value={state?.displayFormat}
                        styles={customStylesForOCP}
                        maxMenuHeight={120}
                        placeholder={t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.SELECT_POINT_MEASURE')}
                        isLoading={state?.loading}
                        onChange={(selected) => handleChange('displayFormat', selected)}
                      />
                      {state.hasError && !state?.displayFormat && (
                        <span className="error-message">{t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.DISPLAY_FORMAT_REQUIRED')}</span>
                      )}
                    </Col>
                  </>
                )}
                <Col lg={12} className="mb-3">
                  <div className="input-group form-floating-label fixed-label">
                    <input
                      type="text"
                      name="ColumnName"
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.SOURCE_COMPONENTS.ENTER_COLUMN')}
                      className="form-control f-14"
                      maxLength={30}
                      value={state?.name}
                      onChange={(e) => handleChange('name', e?.target?.value)}
                    />
                    <label className="asterisk-req f-14 mb-0">{t('CUSTOM_LIBRARY.SOURCE_TYPE.COLUMN_TITLE')}</label>
                  </div>

                  {state?.hasError && !state?.name?.trim().length && (
                    <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.COLUMN_TITLE_MISSING')}</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="modal-buttons mt-2 mt-md-5 d-flex justify-content-between">
              <button type="button" onClick={handleClose} className="btn btn-default">
                {t('CUSTOM_LIBRARY.SOURCE_TYPE.CANCEL')}
              </button>
              <button type="button" onClick={handleSubmit} className="btn btn-default" disabled={state?.mainLoader}>
                {!customLibraryDetail?.pages?.[pageIndex]?.grid?.[gridIndex]?.control?.relation
                  ? t('CUSTOM_LIBRARY.SOURCE_TYPE.CREATE')
                  : t('CUSTOM_LIBRARY.SOURCE_TYPE.UPDATE')}
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
